//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IOpChangeState, IJsonSerializable, IOpData } from '../util/interfaces'
import { DataProvider } from '../../helpers/data-provider'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'

export class OpActionData implements IOpChangeState, IJsonSerializable, IOpData {
    public idActionData: number
    public idDataType: number
    public indexNbr: number
    public value: any

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end

    //#region IOpData Implementation

    public get indexNBR() { return this.indexNBR }
    public set indexNBR(indexNBR: number) { this.indexNBR = indexNBR }

    public get idData() { return this.idActionData }
    public set idData(idData: number) { this.idActionData = idData }

    //#endregion

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idActionData = opObj.ID_ACTION_DATA
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            if (opObj._DataType) {
                this.dataType = new OpDataType(opObj._DataType)
            }

            this.opState = opObj.OpState
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ACTION_DATA: this.idActionData,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value, 
            OpState: this.opState
        }
    }

    public toString() {
        return "ActionData [" + this.idActionData + "]";
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpActionData[]): JQueryPromise<OpActionData[]> {
        var defered = $.Deferred<OpActionData[]>()

        defered.resolve(list)

        return defered.promise()
    }
}